import React from 'react'
import { Badge } from 'react-bootstrap';
const ModuleDisplayBoolean = ({ value, trueValue = 'Yes', falseValue = "No" }) => {
    return (
        <>{((value === '1' || value === 1) ? <Badge bg="success">{trueValue}</Badge> : <Badge bg="warning" text="dark">{falseValue}</Badge>)}</>
    )
}

export default ModuleDisplayBoolean